import { render, staticRenderFns } from "./GreenCoffeeBulkImportTab.vue?vue&type=template&id=282e3216&scoped=true"
import script from "./GreenCoffeeBulkImportTab.vue?vue&type=script&lang=js"
export * from "./GreenCoffeeBulkImportTab.vue?vue&type=script&lang=js"
import style0 from "./GreenCoffeeBulkImportTab.vue?vue&type=style&index=0&id=282e3216&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282e3216",
  null
  
)

export default component.exports